import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import {
  comparisonTone,
  formatComparisonPercent,
  formatCurrency,
  formatInteger,
  formatSellThrough,
} from './pricingLevelPerformanceUtils'

function ExecutiveSummaryCard({ title, value, subtitle, tone = 'neutral' }) {
  return (
    <Card
      body
      className={`card--xs card-with-border executive-summary-card executive-summary-card--${tone}`}
    >
      <p className="executive-summary-card__label">{title}</p>
      <p className="executive-summary-card__value">{value}</p>
      {subtitle ? (
        <p
          className={`executive-summary-card__subtitle executive-summary-card__subtitle--${tone}`}
        >
          {subtitle}
        </p>
      ) : null}
    </Card>
  )
}

export default function PricingLevelExecutiveSummary({ executiveSummary }) {
  if (!executiveSummary) return null

  const revenueTone = comparisonTone(
    executiveSummary.pricingLevelsRevenue?.paceDifferencePercentage
  )
  const sellThroughTone = comparisonTone(
    executiveSummary.sellThrough?.vsAveragePercentagePoints
  )

  return (
    <div className="pricing-level-executive-summary">
      <h2 className="h5 mb-3">Executive summary</h2>
      <Row className="g-3">
        <Col sm={6} xl={3}>
          <ExecutiveSummaryCard
            title="Pricing Levels Revenue"
            value={formatCurrency(executiveSummary.pricingLevelsRevenue?.value)}
            subtitle={formatComparisonPercent(
              executiveSummary.pricingLevelsRevenue?.paceDifferencePercentage,
              'pace'
            )}
            tone={revenueTone}
          />
        </Col>
        <Col sm={6} xl={3}>
          <ExecutiveSummaryCard
            title="Sell Through"
            value={formatSellThrough(executiveSummary.sellThrough?.percentage)}
            subtitle={formatComparisonPercent(
              executiveSummary.sellThrough?.vsAveragePercentagePoints,
              'avg'
            )}
            tone={sellThroughTone}
          />
        </Col>
        <Col sm={6} xl={3}>
          <ExecutiveSummaryCard
            title="Revenue At Risk"
            value={formatCurrency(executiveSummary.revenueAtRisk?.amount)}
            subtitle={`${formatInteger(executiveSummary.revenueAtRisk?.seats)} seats`}
            tone="neutral"
          />
        </Col>
        <Col sm={6} xl={3}>
          <ExecutiveSummaryCard
            title="Best Performer"
            value={executiveSummary.bestPerformer?.name || '—'}
            subtitle={`${formatSellThrough(
              executiveSummary.bestPerformer?.sellThroughPercentage
            )} sold`}
            tone="positive"
          />
        </Col>
      </Row>
    </div>
  )
}
